import slick from 'slick-carousel';
import $ from 'jquery';

export default {

	init() {

		var container = document.querySelector('.relatedProductSlick');
		
		if( container ) {
      		
			$(container).on('breakpoint', function(event, slick, breakpoint) {

                $(container).find('.basic__title').removeClass('fit-content');
                setTimeout(function(){ $(container).find('.basic__title').addClass('fit-content'); }, 500);

            });
            
            $(container).on('init', function(slick) {

                $(container).find('.basic__title').removeClass('fit-content');
                setTimeout(function(){ $(container).find('.basic__title').addClass('fit-content'); }, 500);
                
            });

			$(container).slick({
				arrows : false,
				slidesToShow : 4,
				slidesToScroll : 1,
				infinite : true,
				autoplay: true,
				autoplaySpeed: 2000,
        		rows: 0,
				responsive : [
					{
						breakpoint : 1101,
						settings : {
							slidesToShow : 3,
						}
					},
					{
						breakpoint : 701,
						settings : {
							slidesToShow: 2,
						}
					},
					{
						breakpoint : 331,
						settings : {
							slidesToShow: 1,
						}
					}
				]
			});

		}

	},
	finalize() {

	}

}